import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '@/components/Layout/Layout'
import HomePage from '@/pages/HomePage'
import AboutPage from '@/pages/AboutPage'
import SanliurfaVeterinerPage from '@/pages/SanliurfaVeteriner'
import KarakopruHub from '@/pages/Local/KarakopruHub'
import NeighborhoodDetail from '@/pages/Local/NeighborhoodDetail'
import SpeciesHub from '@/pages/Species/SpeciesHub'
import SpeciesTopicPage from '@/pages/Species/SpeciesTopicPage'
import AcilVeterinerPage from '@/pages/AcilVeteriner'
import KisirlastirmaPage from '@/pages/Kisirlastirma'
import RontgenFiyatlariPage from '@/pages/RontgenFiyatlari'
import ClinicIndex from '@/pages/Clinic/ClinicIndex'
import ClinicDetail from '@/pages/Clinic/ClinicDetail'
import ServicesIndex from '@/pages/Services/ServicesIndex'
import ServiceDetail from '@/pages/Services/ServiceDetail'
import DiseasesIndex from '@/pages/Diseases/DiseasesIndex'
import DiseaseCategory from '@/pages/Diseases/DiseaseCategory'
import DiseaseDetail from '@/pages/Diseases/DiseaseDetail'
import PetsPage from '@/pages/PetsPage'
import ContactPage from '@/pages/ContactPage'
import ScrollToTop from '@/components/Common/ScrollToTop'
import PrivacyPage from '@/pages/PrivacyPage'
import TermsPage from '@/pages/TermsPage'
import NotFoundPage from '@/pages/NotFoundPage'

const App: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="sanliurfa-veteriner" element={<SanliurfaVeterinerPage />} />
        {/* Karaköprü hizmet bölgesi: hub + mahalle sayfaları */}
        <Route path="karakopru-veteriner" element={<KarakopruHub />} />
        <Route path="karakopru-veteriner/:slug" element={<NeighborhoodDetail />} />

        {/* Tür bazlı içerik merkezleri: /kedi, /kopek ve alt konuları */}
        <Route path="kedi">
          <Route index element={<SpeciesHub speciesKey="kedi" />} />
          <Route path=":topic" element={<SpeciesTopicPage speciesKey="kedi" />} />
        </Route>
        <Route path="kopek">
          <Route index element={<SpeciesHub speciesKey="kopek" />} />
          <Route path=":topic" element={<SpeciesTopicPage speciesKey="kopek" />} />
        </Route>
        <Route path="acil-veteriner" element={<AcilVeterinerPage />} />
        <Route path="kisirlastirma" element={<KisirlastirmaPage />} />
        <Route path="rontgen-fiyatlari" element={<RontgenFiyatlariPage />} />
        {/* Eski/İngilizce yollar: tekrar eden içerik oluşmaması için kanonik Türkçe yola yönlendirilir */}
        <Route path="services" element={<Navigate to="/hizmetler" replace />} />
        <Route path="diseases" element={<Navigate to="/hastaliklari" replace />} />

        {/* Eski Wix sitesinden gelen ve Google'ın indekslediği yol */}
        <Route path="iletisim" element={<Navigate to="/contact" replace />} />
        <Route path="pets" element={<PetsPage />} />
        <Route path="contact" element={<ContactPage />} />
        
        {/* Clinic Pages */}
        <Route path="klinik" element={<ClinicIndex />} />
        <Route path="klinik/:slug" element={<ClinicDetail />} />
        
        {/* Service Pages */}
        <Route path="hizmetler" element={<ServicesIndex />} />
        <Route path="hizmetler/:slug" element={<ServiceDetail />} />
        
        {/* Disease Pages */}
        <Route path="hastaliklari" element={<DiseasesIndex />} />
        <Route path="hastaliklari/:category" element={<DiseaseCategory />} />
        <Route path="hastaliklari/:category/:slug" element={<DiseaseDetail />} />
        
        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
      </Route>
    </Routes>
    </>
  )
}

export default App
